module.exports = __webpack_public_path__ + "static/media/GBR Care Infographic home page Mobile - GBR care - 15-04-2025 N.43bfca0b.gif";